//#region packages/@mantine/core/src/core/utils/deep-merge/deep-merge.ts
function isObject(item) {
	return item && typeof item === "object" && !Array.isArray(item);
}
function deepMerge(target, source) {
	const result = { ...target };
	const _source = source;
	if (isObject(target) && isObject(source)) Object.keys(source).forEach((key) => {
		if (isObject(_source[key])) if (!(key in target)) result[key] = _source[key];
		else result[key] = deepMerge(result[key], _source[key]);
		else result[key] = _source[key];
	});
	return result;
}
//#endregion
export { deepMerge };

//# sourceMappingURL=deep-merge.mjs.map